import cx from 'classnames';
import React from 'react';
import Heading from '../Heading';
import styles from './ChevronLink.module.scss';
const addChevron = (text = '') => {
    const words = text.split(' ');
    const lastWord = words.pop();
    const textWithoutLastWord = words.join(' ');
    return (<>
      {textWithoutLastWord} <span className={styles.lastWord}>{lastWord}</span>
    </>);
};
export const ChevronLink = ({ className = '', level = 0, text, href, onClick, CustomLink, }) => {
    const link = (<CustomLink path={href} onClick={onClick} className={cx(styles.chevronLink, className)}>
      {addChevron(text)}
    </CustomLink>);
    if (level > 0) {
        return (<Heading scale={0} level={level}>
        {link}
      </Heading>);
    }
    return link;
};
